import { Component, ErrorInfo, ReactNode } from 'react';
interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

export class GlobalErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
    errorInfo: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, errorInfo: null };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: '#111', color: '#ff5555',
          fontFamily: 'monospace', padding: '2rem',
          zIndex: 999999, overflow: 'auto'
        }}>
          <h1>💥 CRITICAL APP CRASH 💥</h1>
          <p>The game encountered a fatal error and crashed.</p>
          <hr style={{borderColor: '#444'}} />
          <h2>{this.state.error?.toString()}</h2>
          <pre style={{whiteSpace: 'pre-wrap', color: '#ccc'}}>
            {this.state.error?.stack}
          </pre>
          {this.state.errorInfo && (
            <details style={{marginTop: '1rem', color: '#888'}}>
              <summary>Component Stack</summary>
              <pre>{this.state.errorInfo.componentStack}</pre>
            </details>
          )}
          <button
            onClick={() => window.location.reload()}
            style={{ marginTop: '20px', padding: '10px 20px', background: '#ff5555', color: '#fff', border: 'none', cursor: 'pointer', borderRadius: '4px' }}
          >
            Reload Game
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
